import React from "react";
import "./Subheader.scss";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

function Subheader(props) {
  const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

  return (
    <div
      className={`subheader${props.isAreaPage ? " area-subheader" : ""}${isTouchScreen ? " touchscreen" : ""}`}
    >
      <NavLink to="/gallery/videos" activeClassName="active">
        Video
      </NavLink>
      <NavLink to="/gallery/renderings" activeClassName="active">
        Renderings
      </NavLink>
      <NavLink to="/gallery/amenities" activeClassName="active">
        Amenities
      </NavLink>
    </div>
  );
}

export default Subheader;
